import type { MailPreview } from '@/models/api/mail-preview'
import type { ApiFactory, ApiResponse } from '~library/services'

export default class MailPreviewApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 取得信件預覽內容
   * https://hackmd.io/-8ve9Vc9TQin2mAoCT2jtA
   */
  getLetterPreview(guid: string): Promise<ApiResponse<MailPreview>> {
    return this.api.get(`Common/GetLetterPreview/${guid}`)
  }
}
